var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayicon = function SvgPlayicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.167 11.75a1.48 1.48 0 0 1-.713 1.267L6.947 21.28a1.5 1.5 0 0 1-2.075-.516 1.5 1.5 0 0 1-.205-.751V3.488a1.49 1.49 0 0 1 .76-1.295 1.5 1.5 0 0 1 1.52.028l13.507 8.263a1.48 1.48 0 0 1 .713 1.267"
  })));
};
export default SvgPlayicon;